import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import MyConfig from "../../../../Assets/PaymentsAppSidebar/SettingsSubmenu/MyConfig.svg";
import Integrations from "../../../../Assets/PaymentsAppSidebar/SettingsSubmenu/Integrations.svg";
import Identification from "../../../../Assets/PaymentsAppSidebar/SettingsSubmenu/Identification.svg";
import ExternalLinkPointer from "../../../../Assets/PaymentsAppSidebar/SettingsSubmenu/ExternalLinkPointer.svg";
import Users from "../../../../Assets/PaymentsAppSidebar/SettingsSubmenu/Users.svg";
import Admin from "../../../../Assets/PaymentsAppSidebar/SettingsSubmenu/Admin.svg";
import Logout from "../../../../Assets/PaymentsAppSidebar/SettingsSubmenu/Logout.svg";
import { PaymentRoutes } from "../../../../Contracts/Routes";
import { useOnboardingStore } from "../../../../Store/Onboarding";
import { useUserStore } from "../../../../Store/User";

const SettingsSubMenu: React.FC = () => {
  const { user, logout, getAccessTokenSilently } = useAuth0();
  const { resetOnboarding } = useOnboardingStore();
  const { currentUser, getCurrentUser, resetCurrentUser } = useUserStore();

  useEffect(() => {
    getCurrentUser(getAccessTokenSilently);
  }, [getAccessTokenSilently, getCurrentUser]);

  return (
    <div className="flex flex-col justify-between absolute bg-white w-72 border shadow-md h-[calc(100vh-4rem)] z-50">
      <ul>
        <li className="flex bg-gray-100 text-gray-700 items-center border-l">
          {user?.picture ? (
            <img className="w-10 h-10 rounded-full m-2" src={user.picture} alt="Avatar" />
          ) : (
            <></>
          )}
          {user?.name ? <label>{user.given_name}</label> : <label>User</label>}
        </li>
        <li className="border-b py-3 px-4 text-gray-700">
          <a href={PaymentRoutes.SETTINGS_CONFIG} className="flex hover:text-blue-600">
            <img src={MyConfig} alt="My Configuration" />
            <span className="ml-2">My Configuration</span>
          </a>
        </li>
        <li className="border-b py-3 px-4 text-gray-700">
          <a href={PaymentRoutes.SETTINGS_INTEGRATION} className="flex hover:text-blue-600">
            <img src={Integrations} alt="Integrations" />
            <span className="ml-2">Integrations</span>
          </a>
        </li>
        <li className="border-b py-3 px-4 text-gray-700">
          <a href={PaymentRoutes.ONBOARDING_FORM} className="flex hover:text-blue-600">
            <img src={Identification} alt="Customer Identification" />
            <span className="mx-2">Customer Identification</span>
            <img src={ExternalLinkPointer} alt="External link" />
          </a>
        </li>
        <li className="border-b py-3 px-4 text-gray-700">
          <a href={PaymentRoutes.SETTINGS_USERS} className="flex hover:text-blue-600">
            <img src={Users} alt="Users" />
            <span className="ml-2">Users</span>
          </a>
        </li>
        {currentUser?.is_admin && (
          <>
            <li className="flex bg-gray-100 text-gray-700 items-center p-3 border-b">
              <img src={Admin} alt="Users" className="w-4 h-4" />
              <div className="ml-2">Admin</div>
            </li>
            <li className="border-b py-3 px-4 text-gray-700">
              <a href={PaymentRoutes.ADMIN_TEAMS} className="flex hover:text-blue-600">
                <img src={Users} alt="Users" />
                <span className="ml-2">Partners</span>
              </a>
            </li>
          </>
        )}
      </ul>
      <ul>
        <li
          className="border-t py-3 px-4 text-gray-700"
          onClick={async () => {
            resetOnboarding();
            resetCurrentUser();
            await logout({
              logoutParams: { returnTo: window.location.origin }
            });
          }}
        >
          <div className="flex hover:text-blue-600 cursor-pointer">
            <img src={Logout} alt="Logout" />
            <span className="ml-2">Logout</span>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default SettingsSubMenu;
